import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useCreateProductVariationSize = () => {
  return useMutation({
    mutationFn: createProductVariationSize,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.productVariationTypes.all(),
      });
    },
  });
};

const createProductVariationSize = async (data: {
  name: string;
  short?: string;
}) => {
  const url = '/productVariationSizes';

  const response = await requestCCApi(
    {
      url,
      method: 'POST',
      data: {
        data: data,
      },
    },
    false,
  );

  return response.data;
};
